import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import { CheckCircle, Close } from '@mui/icons-material';
import { formatCurrency } from 'components/shared';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const ProductDetailsModal = ({ open, onClose, product = {}, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);

  const price = product.price ?? product.sellingPrice ?? 0;
  const sku = product.sku || product.productCode || '—';
  const categories = Array.isArray(product.categories)
    ? product.categories.join(', ')
    : (product.category?.name || product.category || '—');
  const brand = product.brand?.name || product.brand || '—';
  const inStock = product.stock === undefined || product.stock > 0;

  const handleQuantityChange = (type) => {
    if (type === 'increment' && quantity < 10) {
      setQuantity(quantity + 1);
    } else if (type === 'decrement' && quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleAddToCart = () => {
    if (onAddToCart) {
      for (let i = 0; i < quantity; i += 1) {
        onAddToCart(product);
      }
    }
    setQuantity(1);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <Close />
        </IconButton>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <CheckCircle sx={{ color: inStock ? 'success.main' : 'text.disabled', mr: 1 }} />
          <Typography variant="body2">{inStock ? 'In Stock' : 'Out of Stock'}</Typography>
        </Box>

        <Typography variant="h6">{product.name}</Typography>
        <Typography variant="h4">{formatCurrency(price)}</Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1.5 }}>
          <Button onClick={() => handleQuantityChange('decrement')}>-</Button>
          <Box component="span" sx={{ mx: 1.5 }}>{quantity}</Box>
          <Button onClick={() => handleQuantityChange('increment')}>+</Button>
        </Box>

        <Typography variant="body2">Total Price: {formatCurrency(price * quantity)}</Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleAddToCart}
          disabled={!inStock}
        >
          Add to cart
        </Button>

        <Typography variant="body2" sx={{ mt: 2 }}>
          SKU: {sku}
        </Typography>
        <Typography variant="body2">Categories: {categories}</Typography>
        <Typography variant="body2">Brand: {brand}</Typography>
      </Box>
    </Modal>
  );
};

export default ProductDetailsModal;
